import { render, staticRenderFns } from "./timHome.vue?vue&type=template&id=a25a423e&scoped=true&"
import script from "./timHome.vue?vue&type=script&lang=js&"
export * from "./timHome.vue?vue&type=script&lang=js&"
import style0 from "./timHome.vue?vue&type=style&index=0&id=a25a423e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25a423e",
  null
  
)

export default component.exports